import { CampaignSectionAction, CampaignSectionState } from './OnsiteCampaignSectionState';
import { campaignSectionInitialState } from './campaignSectionInitialState';

export function campaignSectionReducer(
  state: CampaignSectionState,
  action: CampaignSectionAction,
): CampaignSectionState {
  switch (action.type) {
    case 'CLEAR_SELECTED_CAMPAIGN': {
      return { ...state, selectedCampaign: campaignSectionInitialState.selectedCampaign };
    }
    case 'SET_SELECTED_CAMPAIGN': {
      return {
        ...state,
        selectedCampaign: action.payload.selectedCampaign,
      };
    }
  }
}
